import { useTranslation } from 'react-i18next';
import { S, Icon } from '../../regureStyles';

const STATUS_STYLE = {
  pending: { bg: '#eff6ff', border: '#bfdbfe', color: '#1d4ed8', tKey: 'screens.esign.statusPending' },
  partially_signed: { bg: '#fffbeb', border: '#fde68a', color: '#92400e', tKey: 'screens.esign.statusPartial' },
  completed: { bg: '#f0fdf4', border: '#86efac', color: '#15803d', tKey: 'screens.esign.statusCompleted' },
  cancelled: { bg: '#f8fafc', border: '#e2e8f0', color: '#64748b', tKey: 'screens.esign.statusCancelled' },
  expired: { bg: '#fef2f2', border: '#fecaca', color: '#991b1b', tKey: 'screens.esign.statusExpired' },
  declined: { bg: '#fef2f2', border: '#fecaca', color: '#991b1b', tKey: 'screens.esign.statusDeclined' },
  draft: { bg: '#f8fafc', border: '#e2e8f0', color: '#64748b', tKey: 'screens.esign.statusDraft' },
  // Backend transitions a request here when signDocument's sealing step
  // throws. Admins recover via the Retry Seal button (Actions.js).
  seal_failed: { bg: '#fef2f2', border: '#fecaca', color: '#991b1b', tKey: 'screens.esign.statusSealFailed' },
};

function StatusBadge({ status }) {
  const { t } = useTranslation();
  const cfg = STATUS_STYLE[status] || STATUS_STYLE.draft;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '3px 10px',
        borderRadius: 20,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        fontSize: 11,
        fontWeight: 700,
        color: cfg.color,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
      }}
    >
      {t(cfg.tKey)}
    </span>
  );
}

const Header = ({ history, request, loading }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => history.push('/e-signatures')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6, borderRadius: 8 }}>
          <Icon name='arrowLeft' color={S.textMuted} size={20} />
        </button>
        <div>
          <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 2 }}>{t('screens.esign.modalEyebrow')}</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: S.textPrimary }}>{loading ? t('screens.esign.loading') : request?.title || t('screens.esign.requestFallback')}</div>
        </div>
      </div>
      {request && <StatusBadge status={request.status} />}
    </header>
  );
};

export default Header;
